/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-return-assign */
import React, { useEffect } from "react";
import api from "../../services/api";

const Stories: React.FC = () => {
    // const message = `Opa, vi seus stories e tenho interesse no iPhone.`;

    useEffect(() => {
        api.get("/vendedores/loja/proximo/1/stories").then(
            (response: {
                data: { vendedor: { celular: any }; mensagem: any };
            }) =>
                (window.location.href = `https://api.whatsapp.com/send?phone=${response.data.vendedor.celular}&text=${response.data.mensagem}`),
        );
    }, []);

    return <p />;
};

export default Stories;
